<template>
  <v-chart class="radar-chart" :option="radarChartOption"/>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue';
import {use} from 'echarts/core';
import {RadarChart} from 'echarts/charts';
import {LegendComponent, TitleComponent, TooltipComponent} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';
import VChart from 'vue-echarts';
import {AdaptationScreen} from "@/common/js/config.default";

// 注册必要的 ECharts 组件
use([
  RadarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer
]);

//接收父组件传递的数据
const props = defineProps({
  seriesData: Array,
  fontSize: {
    type: Number,
    default: 10
  }
})

const screenType = ref('');

// 雷达图的配置
const radarChartOption = ref({
  title: {
    text: ''
  },
  tooltip: {
    show: false,
  },
  legend: {
    data: []
  },
  radar: {
    radius: '55%',
    // 雷达图的指示器，用来表示多个变量，如性能、能力等
    indicator: [
      {name: '低月供', max: 10},
      {name: '高灵活', max: 10},
      {name: '长贷期', max: 10},
      {name: '低利率', max: 10},
      {name: '低首付', max: 10},
    ],
    name: {
      textStyle: {
        fontSize: props.fontSize,
        color: "#18549C"
      },
    }
  },

  series: [{
    name: '',
    type: 'radar',
    // 数据
    data: props.seriesData
  }]
});

//监听seriesData的变化，更新雷达图配置
watch(() => props.seriesData, (newSeriesData) => {
  radarChartOption.value.series[0].data = newSeriesData;
}, {
  deep: true,
  immediate: true
})

onMounted(() => {
  // console.log('雷达图组件挂载了')
  AdaptationScreen(() => {
    screenType.value = 'mobile'
  }, () => {
    screenType.value = 'pc'
  },);
})
</script>
<style>
.radar-chart {
  //width: 80%;
  //height: 80%;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
